// Pure helpers for consuming the API's { data, pagination } list envelope via
// TanStack Query useInfiniteQuery. Generic — no dependency on any record type.

export interface Page<T> {
  data: T[]
  pagination: { page: number; hasNext: boolean }
}

export function flattenPages<T>(pages: Page<T>[] | undefined): T[] {
  return pages?.flatMap((p) => p.data) ?? []
}

export function nextPageParam<T>(lastPage: Page<T>): number | undefined {
  return lastPage.pagination.hasNext ? lastPage.pagination.page + 1 : undefined
}
